import allLocales from "./all-locales.json";
import localesFallbackMap from "./locales-fallback-map.json";

export enum SupportedLocales {
  IT_IT = "it-IT",
  EN = "en",
  MS = "ms",
  VI = "vi",
  TH = "th",
  ID = "id",
  JA_JP = "ja-JP",
  KO_KR = "ko-KR",
}

export const defaultLocale = SupportedLocales.EN;

export const supportedLocales = Object.keys(localesFallbackMap);

export const supportedCountries = supportedLocales.map((localeCode) => localeCode.split("-")[0]);

export const unsupportedCountries = allLocales.filter(({ code }) => {
  return !supportedCountries.includes(code);
});

export const localeCodeToCountryLanguage: Record<
  SupportedLocales,
  { country: string; language: string }
> = {
  [SupportedLocales.EN]: {
    country: "ww",
    language: "en",
  },
  [SupportedLocales.IT_IT]: {
    country: "it",
    language: "it",
  },
  [SupportedLocales.MS]: {
    country: "my",
    language: "en",
  },
  [SupportedLocales.VI]: {
    country: "vn",
    language: "en",
  },
  [SupportedLocales.TH]: {
    country: "th",
    language: "en",
  },
  [SupportedLocales.ID]: {
    country: "id",
    language: "en",
  },
  [SupportedLocales.JA_JP]: {
    country: "jp",
    language: "ja",
  },
  [SupportedLocales.KO_KR]: {
    country: "kr",
    language: "ko",
  },
};

// add missing locales (this allows to add a language without having to redeploy the code)
supportedLocales.forEach((localeCode) => {
  if (!localeCodeToCountryLanguage[localeCode as SupportedLocales]) {
    const localeParts = localeCode.toLowerCase().split("-");
    if (localeParts.length) {
      localeCodeToCountryLanguage[localeCode as SupportedLocales] = {
        language: localeParts[0],
        country: localeParts.pop() as string,
      };
    }
  }
});
